import {
   fetchWalletStart,
   fetchWalletCompleted,
   fetchWalletFailed,

   fetchWalletPaymentHistoryStart,
   fetchWalletPaymentHistoryCompleted,
   fetchWalletPaymentHistoryFailed,

   fetchNextWalletPaymentHistoryStart,
   fetchNextWalletPaymentHistoryCompleted,
   fetchNextWalletPaymentHistoryFailed,

   wallletPurchaseStart,
   wallletPurchaseCompleted,
   wallletPurchaseFailed,
   setModalState,
} from "./actions";
import { initWallet, initWalletPaymentHistory } from 'sites/api/AuthApi';
import { setSendModalState } from 'sites/state/modules/purchase-send/actions.js';


export const initWalletOperation = (modal = { modalKey: 'top_up' }) => {
   return async (dispatch) => {
      dispatch(fetchWalletStart());
      try {
         const { data }  = await initWallet();
         dispatch(setSendModalState(modal));
         dispatch(fetchWalletCompleted(data));
      } catch (error) {
         dispatch(fetchWalletFailed())
      }
   };
};

export const initWalletPaymentHistoryOperation = (params) => {
   return async (dispatch) => {
      dispatch(fetchWalletPaymentHistoryStart());
      try {
         const { data } = await initWalletPaymentHistory(params);
         dispatch(fetchWalletPaymentHistoryCompleted(data));
      } catch (error) {
         dispatch(fetchWalletPaymentHistoryFailed())
      }
   };
};

export const fetchNextWalletPaymentHistoryOperation = (query) => {
   return async (dispatch) => {
      dispatch(fetchNextWalletPaymentHistoryStart());
      try {
         const { data } = await initWalletPaymentHistory(query);
         dispatch(fetchNextWalletPaymentHistoryCompleted(data));
      } catch (error) {
         dispatch(fetchNextWalletPaymentHistoryFailed())
      }
   };
};

export const wallletPurchaseOperation = type => {
   return async (dispatch) => {
      dispatch(wallletPurchaseStart());
      try {
         setTimeout(() => {
            if(type && type === 'sending') {
               const defaultState = {
                  isOpen: false,
                  type: null,
                  isPaidMessage: false,
                  success: {},
                  buttonText: '',
                  description: '',
               }
               dispatch(setModalState(defaultState));
            } else {
               dispatch(wallletPurchaseCompleted());
            }
         }, 2000);
      } catch (error) {
         dispatch(wallletPurchaseFailed())
      }
   };
};
